import { render, staticRenderFns } from "./GymCreateYourAccount.vue?vue&type=template&id=42f54525"
import script from "./GymCreateYourAccount.vue?vue&type=script&lang=js"
export * from "./GymCreateYourAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports